// Visibility only. Privileged APIs must enforce the current server-side policy.
export function isPlatformAdmin(user: { platformAdmin?: boolean; role?: string } | null | undefined): boolean {
  return user?.platformAdmin === true && (user.role === 'owner' || user.role === 'admin')
}
